import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const rawMaterialSchema = ({ t, data }) => {
  const fertilizersExtraFields = {}

  if (data.agricultural_input_type_id === '2') {
    Object.assign(fertilizersExtraFields, {
      agricultural_input_sub_type_id: required({ t })(Yup.string()),
      type_product: required({ t })(Yup.string())
    })
  }

  return Yup.object().shape({
    name: required({ t })(Yup.string()),
    agricultural_input_type_id: required({ t })(Yup.string()),
    ...fertilizersExtraFields
  })
}

export default rawMaterialSchema
